// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"211":"7b73c3b8","286":"f626a158","379":"79c0a6d1","724":"1a102139","821":"afcf95de"}[chunkId] + ".css";
};